interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "SSP";
};

const SSP: Currency = Object.freeze({
  "displayName": "South Sudanese Pound",
  "numericCode": 728,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "SSP",
  "symbol": "£"
});

export { SSP };
